import { Dispatch, SetStateAction, useEffect, useState } from 'react';

/**
 * Essentially wrapper around `useState` that changes state whenever `initialState` changes by reference
 */
const useControlledState = <TState>(
  initialState: TState,
): [TState, Dispatch<SetStateAction<TState>>] => {
  const [state, setState] = useState<TState>(initialState);

  useEffect(() => {
    setState(initialState);
  }, [initialState]);

  return [state, setState];
};

export default useControlledState;
